import { IOfficeField } from '@pages/office/models/office-data.model';

export class VBConversionImplementation {
  static Val(input: string): number {
    if (!input) return 0;
    const match = input.match(/^[-+]?\d*\.?\d+/);
    return match ? parseFloat(match[0]) : 0;
  }
}

export class StringExtensions {
  static left(str: string, length: number): string {
    return str.substring(0, length);
  }

  static right(str: string, length: number): string {
    return str.substring(str.length - length);
  }
}

//Helper class with FormatMultiPart function that handles specifically MultiPart type of masks
export class InputMaskHelper {
  static formatMultiPartIfApplicable(value: string, officeField: IOfficeField): string {
    if (!officeField?.InputMask) return value;
    const inputMaskConfig = officeField.InputMaskConfig;
    if (inputMaskConfig?.isMultipartMask) {
      return InputMaskHelper.formatMultiPart(value, officeField.InputMask).trimEnd();
    } else if (inputMaskConfig?.justification) {
      return InputMaskHelper.formatJustification(value, officeField.InputMask, officeField.InputLength).trimEnd();
    } else {
      return value;
    }
  }

  static formatMultiPart(value: string, mask: string, recursiveCall = false, valSeparator: string | null = null): string {
    if (!recursiveCall && !value?.trim()) return '';

    if (mask.startsWith('#')) return value; // Numeric format case

    if (mask.length === 2) mask += 'N'; // If length is 2, assume Null separator at end
    if (mask.length < 3) return '';

    const count = Math.trunc(VBConversionImplementation.Val(mask));
    const just = mask.substring(count.toString().length, count.toString().length + 1);
    const separator = mask.substring(count.toString().length + 1, count.toString().length + 2).trim() || 'N';

    if (!valSeparator && separator !== 'N') valSeparator = separator; // Store separator for the mask initially

    const nformat = mask.substring(mask.indexOf(separator) + 1);

    let cut: number;
    let leftover: string, frmtString: string;
    if (separator !== 'N') {
      cut = value.indexOf(separator);
      if (cut <= 0) cut = value.length + 1;

      if (cut - 1 >= count) {
        frmtString = StringExtensions.left(value, count);
        leftover = StringExtensions.right(value, value.length - frmtString.length);
      } else {
        frmtString = StringExtensions.left(value, cut);
        leftover = StringExtensions.right(value, value.length - 1 - frmtString.length);
      }
    } else {
      frmtString = StringExtensions.left(value, count);
      leftover = StringExtensions.right(value, value.length - frmtString.length);
    }

    if (frmtString.length < count) {
      const padding = ' '.repeat(count - frmtString.length);

      switch (just.toUpperCase()) {
        case 'L': // Left justified
          frmtString += padding;
          break;
        case 'R': // Right justified
          frmtString = padding + frmtString;
          break;
        case 'F': // Fixed
          break;
        default:
          return '';
      }
    }

    if (separator !== 'N') {
      frmtString += separator;
      if (leftover.startsWith(separator)) {
        leftover = leftover.substring(1);
      }
    } else {
      if (frmtString.endsWith(valSeparator || '') && valSeparator !== null) {
        frmtString = frmtString.replace(valSeparator || '', ' ');
      }
    }

    return nformat.length > 0 ? frmtString + InputMaskHelper.formatMultiPart(leftover, nformat, true, valSeparator) : frmtString;
  }

  static formatJustification(value: string, justification: string, count: number): string {
    let result = value ?? '';

    if (result.length > count) {
      result = result.substring(0, count);
    }
    const padding = ' '.repeat(count - result.length);

    switch (justification.toUpperCase()) {
      case 'R': // Right Justified
        result = padding + result;
        break;
      case 'L': // Left Justified
      case 'F': // Fixed Length
        result = result + padding;
        break;
      case 'LUCASE': // Left Justified Upper Case
      case 'FUCASE': // Fixed Upper Case
        result = result.toUpperCase() + padding;
        break;
      default:
        break;
    }
    return result;
  }
}
